// Where a visitor came from, so a consultation request reaches VEC_MS with its marketing
// source (TikTok, Instagram, Facebook…) — the CMO's KPIs count leads per platform.
//
// The CMO tags the links he posts, e.g. visionexploit.com/?utm_source=tiktok&utm_medium=social&utm_campaign=tino-launch.
// The tags are kept for this browser tab only (sessionStorage), first link wins, and are sent
// with the form. No cookie, no third-party tracker.

const KEY = 'vec_utm';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign'];

export const HOW_HEARD_CHOICES = [
  { value: '', label: 'Choose one (optional)' },
  { value: 'TIKTOK', label: 'TikTok' },
  { value: 'INSTAGRAM', label: 'Instagram' },
  { value: 'FACEBOOK', label: 'Facebook' },
  { value: 'WHATSAPP', label: 'WhatsApp' },
  { value: 'WEBSITE', label: 'Google / searching online' },
  { value: 'REFERRAL', label: 'A friend, family or former student' },
  { value: 'AGENT', label: 'An agent or partner' },
  { value: 'SCHOOL_VISIT', label: 'A school visit' },
  { value: 'EVENT', label: 'An event or expo' },
  { value: 'OTHER', label: 'Other' },
];

export function captureUtm() {
  try {
    if (sessionStorage.getItem(KEY)) return;
    const params = new URLSearchParams(window.location.search);
    const found = {};
    UTM_KEYS.forEach((k) => {
      const v = (params.get(k) || '').trim().slice(0, 100);
      if (v) found[k] = v;
    });
    if (Object.keys(found).length) sessionStorage.setItem(KEY, JSON.stringify(found));
  } catch {
    // Storage blocked (private mode): the form still works, just without the link's tags.
  }
}

export function getUtm() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || '{}') || {};
  } catch {
    return {};
  }
}

// Adds the stored tags to a form payload (never overwrites a value already set).
export function withAttribution(data) {
  return { ...getUtm(), ...data };
}
